import Home from "../views/Dashboard/Home.jsx";
import Tenants from "../views/Tables/TenantsTable.jsx";
import EditTenantForm from "../views/Forms/EditTenant.jsx";
import AddTenantForm from "../views/Forms/AddTenant.jsx";
import Artists from "../views/Tables/ArtistsTable.jsx";
import AddArtistForm from "../views/Forms/AddArtist.jsx";
import EditArtistForm from "../views/Forms/EditArtist.jsx";
import Clauses from "../views/Tables/ClausesTable.jsx";
import AddClauseForm from "../views/Forms/AddClause.jsx";
import EditClauseForm from "../views/Forms/EditClause.jsx";
import Consents from "../views/Tables/ConsentsTable.jsx";
import AddConsentForm from "../views/Forms/AddConsent.jsx";
import EditConsentForm from "../views/Forms/EditConsent.jsx";
import KioskMode from "../views/Tables/KioskTable.jsx";
import ConsentSubmissions from "../views/Tables/SubmissionsTable.jsx";
import AllConsentSubmissions from "../views/Tables/AllSubmissionsTable.jsx";
//import ConsentFormWizard from "views/Forms/ConsentFormWizard/DisplayConsentWizard.jsx";
import ConsentFormWizard from "../views/Forms/DisplayConsentFormWizard/DisplayConsentWizard.jsx";
import EditProfileForm from "../views/Forms/EditProfile.jsx";
import KioskUsers  from "../views/Tables/KioskUsersTable.jsx";
import EditKioskUsersForm from "../views/Forms/EditKioskUser.jsx";
import AddKioskUserForm from "../views/Forms/AddKioskUser.jsx";
import DisplaySubmissionForm from "../views/Forms/DisplaySubmission.jsx";
import RegisterPage from "../views/Pages/RegisterPage.jsx";
import RegisterWizard from "../views/Forms/RegisterWizard/RegisterWizard.jsx";
import ManageSubscriptionWizard from "../views/Forms/ManageSubscriptionWizard/ManageSubscriptionWizard.jsx";
import ContactPage from "../views/Dashboard/Contact.jsx";
import LegalPage from "../views/Dashboard/Legal.jsx";
import PricingPage from "../views/Pages/PricingPage.jsx";
import SubscriptionEvents from "../views/Tables/SubscriptionEventsTable.jsx";
import ProcessSubscriptionForm from "../views/Forms/EditSubscription.jsx";
import OnlineHelp from "../views/Dashboard/Help.jsx";

/*
import Buttons from "views/Components/Buttons.jsx";
import GridSystem from "views/Components/GridSystem.jsx";
import Panels from "views/Components/Panels.jsx";
import SweetAlert from "views/Components/SweetAlertPage.jsx";
import Notifications from "views/Components/Notifications.jsx";
import Icons from "views/Components/Icons.jsx";
import Typography from "views/Components/Typography.jsx";
import RegularForms from "views/Forms/RegularForms.jsx";
import ExtendedForms from "views/Forms/ExtendedForms.jsx";
import ValidationForms from "views/Forms/ValidationForms.jsx";
import RegularTables from "views/Tables/RegularTables.jsx";
import ExtendedTables from "views/Tables/ExtendedTables.jsx";
import ReactTables from "views/Tables/ReactTables.jsx";
import GoogleMaps from "views/Maps/GoogleMaps.jsx";
import FullScreenMap from "views/Maps/FullScreenMap.jsx";
import VectorMap from "views/Maps/VectorMap.jsx";
import Charts from "views/Charts/Charts.jsx";
*/

//import UserPage from "../views/Pages/UserPage.jsx";

//import pagesRoutes from "./pages.jsx";

/*
var pages = [
  { path: "/pricing-page", name: "Pricing", mini: "UP", component: PricingPage }
].concat(pagesRoutes);
*/

var dashboardRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: "pe-7s-home",
    component: Home
  },
  {
    path: "/register",
    name: "Register",
    icon: "pe-7s-add-user",
    component: RegisterWizard
  },
    /*
  {
    path: "/pages/register-page",
    name: "Register",
    icon: "pe-7s-add-user",
    component: RegisterWizard
  },
  */
  {
    path: "/pages/pricing-page",
    name: "Pricing",
    icon: "pe-7s-cash",
    component: PricingPage
  },
  {
    path: "/tenants",
    name: "Tenants",
    icon: "pe-7s-call",
    invisible: true,
    component: Tenants
  },
  {
     path: "/addtenant",
     name: "Add Tenant",
     icon: "pe-7s-call",
     invisible: true,
     component: AddTenantForm
  },
  {
    path: "/edittenant/:id",
    name: "Edit Tenant",
    icon: "pe-7s-call",
    invisible: true,
    component: EditTenantForm
  },
  {
    path: "/artists",
    name: "Our Artists",
    icon: "pe-7s-call",
    invisible: true,
    component: Artists
  },
  {
    path: "/addartist",
    name: "Add Artist",
    icon: "pe-7s-call",
    invisible: true,
    component: AddArtistForm
  },
  {
    path: "/editartist/:id",
    name: "Edit Artist",
    icon: "pe-7s-call",
    invisible: true,
    component: EditArtistForm
  },
  {
    path: "/clauses",
    name: "Our Consent Clauses",
    icon: "pe-7s-call",
    invisible: true,
    component: Clauses
  },
  {
    path: "/addclause",
    name: "Add Consent Clause",
    icon: "pe-7s-call",
    invisible: true,
    component: AddClauseForm
  },
  {
    path: "/editclause/:id",
    name: "Edit Consent Clause",
    icon: "pe-7s-call",
    invisible: true,
    component: EditClauseForm
  },
  {
    path: "/consents",
    name: "Our Consent Forms",
    icon: "pe-7s-call",
    invisible: true,
    component: Consents
  },
  {
    path: "/addconsent",
    name: "Add Consent Form",
    icon: "pe-7s-call",
    invisible: true,
    component: AddConsentForm
  },
  {
    path: "/editconsent/:id",
    name: "Edit Consent",
    icon: "pe-7s-call",
    invisible: true,
    component: EditConsentForm
  },
  {
    path: "/Profile",
    name: "Edit My Profile",
    icon: "pe-7s-call",
    invisible: true,
    component: EditProfileForm
  },
  {
    path: "/displayconsentform/:id",
    name: "Display Consent",
    icon: "pe-7s-call",
    invisible: true,
    component: ConsentFormWizard
  },
  {
    path: "/kioskusers",
    name: "Our Kiosk Users",
    icon: "pe-7s-call",
    invisible: true,
    component: KioskUsers
  },
  {
    path: "/addkioskuser",
    name: "Add Kiosk User",
    icon: "pe-7s-call",
    invisible: true,
    component: AddKioskUserForm
  },
  {
    path: "/editkioskuser/:id",
    name: "Edit Kiosk User",
    icon: "pe-7s-call",
    invisible: true,
    component: EditKioskUsersForm
  },
  {
    path: "/kioskmode",
    name: "Kiosk Mode",
    icon: "pe-7s-call",
    invisible: true,
    component: KioskMode
  },
  {
    path: "/submissions",
    name: "Our Consent Submissions",
    icon: "pe-7s-call",
    invisible: true,
    component: ConsentSubmissions
  },
  {
    path: "/allsubmissions",
    name: "All Submissions",
    icon: "pe-7s-call",
    invisible: true,
    component: AllConsentSubmissions
  },
  {
    path: "/displaysubmissionform/:id",
    name: "Display a Submission Form",
    icon: "pe-7s-call",
    invisible: true,
    component: DisplaySubmissionForm
  },
  {
    path: "/contact",
    name: "Contact Us",
    icon: "pe-7s-call",
    component: ContactPage
  },
  {
    path: "/legal",
    name: "Legal Stuff",
    icon: "pe-7s-hammer",
    component: LegalPage
  },
  {
    path: "/help",
    name: "Online Help",
    icon: "pe-7s-help",
    invisible: true,
    component: OnlineHelp
  },
  {
    path: "/managesubscriptions",
    name: "Manage Subscription Events",
    icon: "pe-7s-call",
    invisible: true,
    component: SubscriptionEvents
  },
  {
    path: "/processsubscriptionform/:id",
    name: "Process Subscription Event",
    icon: "pe-7s-call",
    invisible: true,
    component: ProcessSubscriptionForm
  },
  {
    path: "/mysubscription",
    name: "Manage My Subscription",
    icon: "pe-7s-call",
    invisible: true,
    component: ManageSubscriptionWizard
  },
  /*
  {
    path: "/contact",
    name: "Contact Us",
    icon: "pe-7s-call",
    component: Contact
  },
  {
    collapse: true,
    path: "/components",
    name: "Components",
    state: "openComponents",
    icon: "pe-7s-plugin",
    views: [
      {
        path: "/components/buttons",
        name: "Buttons",
        mini: "B",
        component: Buttons
      },
      {
        path: "/components/grid-system",
        name: "Grid System",
        mini: "GS",
        component: GridSystem
      },
      {
        path: "/components/panels",
        name: "Panels",
        mini: "P",
        component: Panels
      },
      {
        path: "/components/sweet-alert",
        name: "Sweet Alert",
        mini: "SA",
        component: SweetAlert
      },
      {
        path: "/components/notifications",
        name: "Notifications",
        mini: "N",
        component: Notifications
      },
      { path: "/components/icons", name: "Icons", mini: "I", component: Icons },
      {
        path: "/components/typography",
        name: "Typography",
        mini: "T",
        component: Typography
      }
    ]
  },

  {
    collapse: true,
    path: "/forms",
    name: "Forms",
    state: "openForms",
    icon: "pe-7s-note2",
    views: [
      {
        path: "/forms/regular-forms",
        name: "Regular Forms",
        mini: "RF",
        component: RegularForms
      },
      {
        path: "/forms/extended-forms",
        name: "Extended Forms",
        mini: "EF",
        component: ExtendedForms
      },
      {
        path: "/forms/validation-forms",
        name: "Validation Forms",
        mini: "VF",
        component: ValidationForms
      },
      { path: "/forms/wizard", name: "Wizard", mini: "W", component: Wizard }
    ]
  },
  {
    collapse: true,
    path: "/tables",
    name: "Tables",
    state: "openTables",
    icon: "pe-7s-news-paper",
    views: [
      {
        path: "/tables/regular-tables",
        name: "Regular Tables",
        mini: "RT",
        component: RegularTables
      },
      {
        path: "/tables/extended-tables",
        name: "Extended Tables",
        mini: "ET",
        component: ExtendedTables
      },
      {
        path: "/tables/react-table",
        name: "React Table",
        mini: "RT",
        component: ReactTables
      }
    ]
  },
  {
    collapse: true,
    path: "/maps",
    name: "Maps",
    state: "openMaps",
    icon: "pe-7s-map-marker",
    views: [
      {
        path: "/maps/google-maps",
        name: "Google Maps",
        mini: "GM",
        component: GoogleMaps
      },
      {
        path: "/maps/full-screen-maps",
        name: "Full Screen Map",
        mini: "FSM",
        component: FullScreenMap
      },
      {
        path: "/maps/vector-maps",
        name: "Vector Map",
        mini: "VM",
        component: VectorMap
      }
    ]
  },
  { path: "/charts", name: "Charts", icon: "pe-7s-graph1", component: Charts },
  {
    path: "/calendar",
    name: "Calendar",
    icon: "pe-7s-date",
    component: Calendar
  },
  {
    collapse: true,
    path: "/pages",
    name: "Pages",
    state: "openPages",
    icon: "pe-7s-gift",
    views: pages
  },*/
  { redirect: true, path: "/", pathTo: "/home", name: "Home" }
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx